export const aowLeeftijd = {
	values: {
		"0000-01-01": {
			value: [
				{ vanaf: "0000-01-01", jaar: 65, maanden: 0 },
				{ vanaf: "1948-01-01", jaar: 65, maanden: 1 },
				{ vanaf: "1948-12-01", jaar: 65, maanden: 2 },
				{ vanaf: "1949-11-01", jaar: 65, maanden: 3 },
				{ vanaf: "1950-08-01", jaar: 65, maanden: 6 },
				{ vanaf: "1951-05-01", jaar: 65, maanden: 9 },
				{ vanaf: "1952-02-01", jaar: 66, maanden: 0 },
				{ vanaf: "1952-06-01", jaar: 66, maanden: 4 },
				{ vanaf: "1953-09-01", jaar: 66, maanden: 7 },
				{ vanaf: "1954-09-01", jaar: 66, maanden: 10 },
				{ vanaf: "1955-09-01", jaar: 67, maanden: 0 },
				{ vanaf: "1961-01-01", jaar: 67, maanden: 3 },
				{ vanaf: "1966-07-01", jaar: 67, maanden: 6 },
				{ vanaf: "1969-04-01", jaar: 67, maanden: 9 },
				{ vanaf: "1972-01-01", jaar: 68, maanden: 0 },
				{ vanaf: "1975-10-01", jaar: 68, maanden: 3 },
				{ vanaf: "1978-07-01", jaar: 68, maanden: 6 },
				{ vanaf: "1981-04-01", jaar: 68, maanden: 9 },
				{ vanaf: "1985-01-01", jaar: 69, maanden: 0 },
				{ vanaf: "1988-10-01", jaar: 69, maanden: 3 },
				{ vanaf: "1992-07-01", jaar: 69, maanden: 6 },
				{ vanaf: "1995-04-01", jaar: 69, maanden: 9 },
				{ vanaf: "1999-01-01", jaar: 70, maanden: 0 },
			],
		},
	},
};
